/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { cn } from "lib/utils/shadcn";
import Loading from "../Loading/Loading";

const LoadingScreen = ({ bgColor = "#1a1a1a", className = "" }) => (
  <div
    className={cn(
      "flex items-center justify-center h-screen w-full",
      className,
    )}
    test-id="SAwsho1k"
  >
    <Loading className="h-48 w-48" bgColor={bgColor} test-id="4jQThNHC" />
  </div>
);

export default LoadingScreen;
